import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {Button} from "antd"
import styled from "styled-components"
import 'swiper/css'
import MultiServiceSwiper from "./components/MultiServiceSwiper"
import {useEffect} from "react"
import {useNavigate} from "react-router-dom"

const HomeScreen = () => {
	const navigate = useNavigate()

	useEffect(() => {
		document.title = 'АТС24 — цифровая логистика, маршрутизация, мониторинг, мобильное приложение для водителя'
	}, [])

	return (
		<>
			<ContentBlock background="#000000" top={3.33} bottom={3.33}>
				<SectionsWrapper>
					<Title>Экосистема<br/>для логистики</Title>
					<Sections>
						<SectionsRow className="row">
							<SectionsCell className="cell">
								<Section onClick={() => navigate('/routing')} color="#479f4d">
									<SectionTitle>
										Маршрутизация
									</SectionTitle>
									<SectionDescription className="section-description">
										Автоматический и ручной режимы
									</SectionDescription>
								</Section>
							</SectionsCell>
							<SectionsCell className="cell">
								<Section onClick={() => navigate('/monitoring')} color="#3787f9">
									<SectionTitle>
										Мониторинг
									</SectionTitle>
									<SectionDescription className="section-description">
										Статус доставки и местоположение транспорта
									</SectionDescription>
								</Section>
							</SectionsCell>
						</SectionsRow>
						<SectionsRow className="row">
							<SectionsCell className="cell">
								<Section onClick={() => navigate('/mobile-app')} color="#ec7336">
									<SectionTitle>
										Мобильное приложение
									</SectionTitle>
									<SectionDescription className="section-description">
										Электронный маршрут и товарные накладные
									</SectionDescription>
								</Section>
							</SectionsCell>
							<SectionsCell className="cell">
								<Section onClick={() => navigate('/services')} color="#2d2d2d">
									<SectionTitle>
										Сервисы
									</SectionTitle>
									<SectionDescription className="section-description">
										Самые современные инструменты для логистики
									</SectionDescription>
								</Section>
							</SectionsCell>
						</SectionsRow>
					</Sections>
				</SectionsWrapper>
			</ContentBlock>

			<ContentBlock background="#F3FFE3">
				<ContentCard title="Простота">
					<p className="description">
						Наши интерфейсы интуитивно понятны, и любой сотрудник освоит их всего за час. Все экраны были
						разработаны с участием логистов, водителей и руководителей отделов.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#E4FF97">
				<ContentCard title="Скорость">
					<p className="description">
						Потрясающая скорость работы даже на офисных ПК. Терминал и маршрутизация эффективно обрабатывают
						большое количество маршрутов, а карта без задержек может отображать более 10 000 точек
						одновременно.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#FFF2DF" bottom={0}>
				<ContentCard title="Сервисы">
					<p className="description">
						Мы внимательно следим за тенденциями рынка логистики и регулярно запускаем
						новые, современные инструменты, доступные сразу всем клиентам.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#FFF2DF" top={0}>
				<MultiServiceSwiper/>
			</ContentBlock>
			<ContentBlock background="#f5f5f5" bottom={0}>
				<ContentCard title="Приложение руководителя" textColor="#000000" radius={0}
							 media={{
								 url: "/assets/img/jpg/home/director-app.jpg",
								 radius: 0
							 }}
				>
					<p>
						Всегда под рукой краткая статистка плюс полная информацию о маршрутах, точках и водителях за
						любой день.
					</p>
					<p>
						<Button onClick={() => navigate('/services/director')} color="default" variant="solid"
								size="large">
							Подробнее о приложении
						</Button>
					</p>
				</ContentCard>
			</ContentBlock>
		</>
	)
}

export default HomeScreen

const SectionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2.22rem;
`
const Title = styled.h1`
    padding-left: 1rem;
    font-size: 3.55rem;
    line-height: 1;
    font-weight: bold;
    color: #FFFFFF;
    @media (max-width: 992px) {
        padding-left: 0;
    }
`
const Sections = styled.div`
    display: flex;
    flex-direction: column;
    color: #FFFFFF;

    @media (max-width: 992px) {
        gap: 1.33rem;
    }
`

const SectionsRow = styled.div`
    display: flex;

    &:not(:last-child) {
        border-bottom: 1px solid #2d2d2d;
    }

    @media (max-width: 992px) {
        flex-direction: column;
        gap: 1.33rem;
        border-bottom: none;
        &:not(:last-child) {
            border: none;
        }
    }
`

const SectionsCell = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 16.66rem;
    cursor: pointer;
    padding: 0.83rem;

    &:not(:last-child) {
        border-right: 1px solid #2d2d2d;
    }

    @media (max-width: 992px) {
        height: auto;
        padding: 0;
        &:not(:last-child) {
            border: none;
        }
    }
`


const Section = styled.div`
    box-sizing: border-box;
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    transition: background-color .3s, transform 0.3s;
    padding: 1.33rem;
    border-radius: 0.88rem;
    transform: scale(1.00524);
    flex-direction: column;
    background-color: #141414;

    :hover {
        background-color: ${props => props.color};
        transform: scale(1.02);

        .section-description {
            opacity: 1;
        }
    }
`

const SectionTitle = styled.h3`
    display: flex;
    flex: 1;
    font-weight: 550;
`
const SectionDescription = styled.div`
    opacity: .6;
    transition: opacity 0.3s;
`